import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import * as Yup from 'yup';
import { RulesetResult } from '../../business/rules';
import { PropertyLeaseExpirationYearRuleset } from '../../business/ruleset/solar_property';

const {
  formField: { systemPropertyLeaseExpirationYear },
} = loanFormModel;

export class PropertyLeaseExpirationYearValidation implements ValidationSchema {
  public name: string = systemPropertyLeaseExpirationYear.name;
  public label = '';
  public dependsOn: string[] = PropertyLeaseExpirationYearRuleset.dependsOn;
  public type = 'date';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public ruleset = PropertyLeaseExpirationYearRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const schema: Yup.StringSchema = args[this.dependsOn.length];
    if (result & RulesetResult.REQUIRED)
      return schema
        .min(new Date().getFullYear(), 'Lease cannot expire in the past')
        .required('This field is required');
    return schema;
  }
}
export default new Validation(new PropertyLeaseExpirationYearValidation());
